/**
 * Web-Formulare -- F3-08, K-45.
 */

import type { components } from '../../api/schema';
import { request } from '../../lib/apiClient';

export type WebForm = components['schemas']['WebFormRead'];
export type WebFormCreate = components['schemas']['WebFormCreate'];
export type WebFormUpdate = components['schemas']['WebFormUpdate'];
export type Submission = components['schemas']['SubmissionRead'];

export function listWebForms(): Promise<WebForm[]> {
  return request<WebForm[]>('/web-forms');
}

export function createWebForm(payload: WebFormCreate): Promise<WebForm> {
  return request<WebForm>('/web-forms', { method: 'POST', body: payload });
}

export function updateWebForm(formId: string, payload: WebFormUpdate): Promise<WebForm> {
  return request<WebForm>(`/web-forms/${formId}`, { method: 'PATCH', body: payload });
}

export function deleteWebForm(formId: string): Promise<undefined> {
  return request<undefined>(`/web-forms/${formId}`, { method: 'DELETE' });
}

export function listSubmissions(formId: string): Promise<Submission[]> {
  return request<Submission[]>(`/web-forms/${formId}/submissions`);
}
